module.exports = __webpack_public_path__ + "static/media/bafu.6a6c1ac6.png";